import {createBaseShape} from './createBaseShape'
export const createTwoHeadsLineArrow = (attrs) => {
  let strokeSize = 2
  let strokeColor = 'black'
  let fillColor

  if (typeof window.strokeSize !== 'undefined') {
    strokeSize = window.strokeSize
  }

  if (typeof window.strokeColor !== 'undefined') {
    strokeColor = window.strokeColor
  }

  if (typeof window.fillColor !== 'undefined') {
    fillColor = window.fillColor
  }

  return Object.assign(
    createBaseShape({
      enabledAnchors: [
        'middle-left',
        'middle-right',
        'top-center',
        'bottom-center'
      ],
      pointerWidth: attrs.pointerWidth,
      shapeType: attrs.shapeType
    }),
    {
      strokeWidth: strokeSize,
      pointerWidth: 10,
      stroke: strokeColor,
      name: 'connector',
      points: [attrs.x, attrs.y, attrs.x + attrs.width, attrs.y]
    }
  )
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/createTwoHeadsLineArrow.js